"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarMenu = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const element_tracker_1 = require("@cs125/element-tracker");
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const useStyles = makeStyles_1.default(theme => ({
    list: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    item: {
        paddingLeft: theme.spacing(1),
        "&:hover": {
            borderLeft: `4px solid ${theme.palette.action.disabled}`,
        },
    },
    active: {
        fontWeight: 900,
        borderLeft: `4px solid ${theme.palette.action.selected}`,
    },
    inactive: {
        fontWeight: "normal",
        borderLeft: "4px solid transparent",
    },
}));
exports.SidebarMenu = ({ top = 0 }) => {
    const { elements } = element_tracker_1.useElementTracker();
    const [activeHeader, setActiveHeader] = react_1.useState(undefined);
    const classes = useStyles();
    react_1.useLayoutEffect(() => {
        if (!elements || elements.length === 0) {
            setActiveHeader(undefined);
            return;
        }
        const activeHeader = element_tracker_1.active(elements.filter(e => e.tagName.toLowerCase() === "h2"), top);
        if (!activeHeader) {
            setActiveHeader(undefined);
            return;
        }
        const id = activeHeader.getAttribute("data-et-id") || activeHeader.id;
        setActiveHeader(id);
    }, [top, elements]);
    if (!elements) {
        return null;
    }
    return (react_1.default.createElement(List_1.default, { dense: true, className: classes.list }, elements
        .filter(e => e.tagName.toLowerCase() === "h2")
        .map((element, i) => {
        const id = element.getAttribute("data-et-id") || element.id;
        const active = activeHeader && id && id === activeHeader;
        return (react_1.default.createElement(ListItem_1.default, { onClick: () => {
                window.location.href = `${window.location.href.split("#")[0]}#${id}`;
            }, key: i },
            react_1.default.createElement(Typography_1.default, { variant: "h4", className: `${classes.item} ${active ? classes.active : classes.inactive}` },
                react_1.default.createElement("span", { onClick: () => setActiveHeader(id) }, element.textContent))));
    })));
};
exports.SidebarMenu.propTypes = {
    top: prop_types_1.default.number,
};
//# sourceMappingURL=SidebarMenu.js.map